<ion-header>
  <ion-toolbar class="blues-nav">
    <ion-row>
      <ion-col size="2" class="nav-back">
        <span class="custom-icon-back-arrow-icon" (click)="back()">
          <span class="path1"></span> <span class="path2"></span> </span>
      </ion-col>
      <ion-col size="10" class="nav-content">
        <ion-title>
          <span>Layout</span>
        </ion-title>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-header>

<ion-content>

</ion-content>
